import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CloseIcon from "@mui/icons-material/Close";

interface RelinkWarningDialogProps {
  open: boolean;
  existingClientName: string;
  newClientName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const RelinkWarningDialog = ({
  open,
  existingClientName,
  newClientName,
  onConfirm,
  onCancel,
}: RelinkWarningDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth slotProps={{ paper: { sx: { borderRadius: "8px", bgcolor: "#fff" } } }}>
      <DialogTitle
        sx={{ display: "flex", alignItems: "center", gap: 1, pr: 6 }}
      >
        <WarningAmberIcon sx={{ color: "#DA1B25" }} />
        <span style={{ flex: 1 }}>{t("coachingNavigator.coachingCalendar.changeClientLinkage")}</span>
        <IconButton
          onClick={onCancel}
          size="small"
          sx={{ position: "absolute", right: 8, top: 8 }}
          aria-label="Close relink warning"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mt: 1 }}>
          {t("coachingNavigator.coachingCalendar.relinkWarningMessage_before")}
          <span style={{ fontWeight: 600 }}>{existingClientName}</span>
          {t("coachingNavigator.coachingCalendar.relinkWarningMessage_middle")}
          <span style={{ fontWeight: 600 }}>{newClientName}</span>
          {t("coachingNavigator.coachingCalendar.relinkWarningMessage_after")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="outlined">
          {t("button.cancel")}
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          {t("coachingNavigator.coachingCalendar.changeClientLinkage")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RelinkWarningDialog;
